import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Color } from 'ng2-charts';

@Component({
  selector: 'app-applications-portfolio',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.css', './custom_style.css', './boot-outline-btn.css']
})
export class ApplicationsPortfolioComponent implements OnInit {
  @Input() from = '';
  due_loans_master = true;
  due_date: '';
  staff_loading = false;
  showperformance = 'no';
  loadingPS = false;
  loading = false;
  currentUser: any;
  platform_summary: any;
  viewing_loan = false;
  loan_viewed = '0';
  parentRouteId: any;
  view_state = '0';
  dontshownext = '0';
  sub: any;
  overlayType = '0';
  loan: any;
  staffs: any;
  title = 'Portfolio (Due vs Repayments)';
  showApprovals = false;
  lender:any;
  public doughnutChartLabels: any[] = ['1 - 15', '16 - 30', '31 - 60', '61 - 90', '91 - 180', '180+'];
  public doughnutChartData: any[] = [];
  public doughnutChartType = 'doughnut';
  public doughnutChartLegend: any = { display: false, position: 'bottom' };
  public doughChartOptions: any = {
    legend: {
      position: 'none'
    },
    percentageInnerCut: 10
  };
  public staff_performance = {
    'staff_id': ''
  }
  public backgroundColor: Array<Color> = [
    {
      backgroundColor: [
        '#00AFEF',
        '#00A859',
        '#FFF212',
        '#ED3237',
        '#a73f3f',
        '#181818',
        '#ff639a',
        '#359f7f',
        '#ff6e6e',
        '#d70d2f',
        '#3E9F09',
        '#961d9f'
      ]
    }
  ];
  staff_performance_result: any;
  ageing_analysis: any;
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public dataService: DataService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService, public route: ActivatedRoute) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.lender = this.storageService.read<any>('platform');
  }
  openAnalytics(request_id) {
    this.router.navigate(['./applications/analytics/' + request_id]);
  }
  ngOnInit() {
    this.runPlatformSummary();
    this.getAgeingAnalysis();
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
    });
    this.getEmployees();
  }
  getEmployees() {
    this.operationsService.getEmployees__(this.currentUser.token, 0, '')
      .subscribe(employees => {
        this.staffs = employees.employees;
      });
  }
  getAgeingAnalysis() {
    this.analytics.reunAgeingAnalysis(this.currentUser.token)
      .subscribe(data => {
        this.ageing_analysis = data.data;
        if (this.ageing_analysis) {
          //this.doughnutChartData = [this.platform_summary.repaid_this_month, this.platform_summary.late_this_month, this.platform_summary.default_this_month];
          this.ageing_analysis.forEach(function (officer) {
            this.doughnutChartData.push(officer.percentage);
          });
        }
      });
  }
  runPlatformSummary() {
    console.log('Running PS');
    this.loadingPS = true;
    this.analytics.runPlatformSummary(this.currentUser.token)
      .subscribe(data => {
        console.log('Done!', data);
        // //console.log(data);
        this.loadingPS = false;
        this.showperformance = 'yes';
        this.platform_summary = data;
        this.dataService.portfolioPlatformSummaryLoaded.emit({ platform_summary: data });
        if (this.platform_summary) {
          this.doughnutChartData = [this.platform_summary.repaid_this_month, this.platform_summary.late_this_month, this.platform_summary.default_this_month];
          //console.log(this.doughnutChartData);
        }
      });
  }
  toFixed(data) {
    if (data) {
      return data.toFixed(2);
    }
  }
  openPortfolioTarget() {
    this.dataService.showPortfolioTarget.emit({ id: this.parentRouteId });
  }
  postBulPay() {
    this.dataService.newBulkPayments.emit();
  }
  runStaffPerformance() {
    this.staff_loading = true;
    this.analytics.runStaffPerformance(this.currentUser.token, this.staff_performance)
      .subscribe(data => {
        // //console.log(data);
        this.staff_loading = false;
        this.staff_performance_result = data;
      });
  }
  showDueLoansList(event) {
    this.dataService.showDueLoansList.emit();
  }
  getDueRepaymentByDate() {
    this.dataService.getDueRepaymentByDate.emit({ due_date: this.due_date });
  }
  switchDueLoansMaster() {
    this.due_loans_master = false;
  }
}
